import Contract from '../containers/contract';
import Navbar from '../components/navbar';

function App() {
    return (
        <div className="main">
            <Navbar></Navbar>
            <div className="title-box">
                <p className="title">Get a fun fact for just <strong>0.01 ETH</strong> <br></br>
                <span className="rinkeby-title">Rinkeby Network</span></p>
                <div className="wallet-position">
                    <Contract></Contract>
                </div>
            </div>
        </div>
    );
}
  
export default App;